<div id="masterheader" class="header">
    <a (click)="header_trg('home')">
        <img class="iconL" src="../assets/img/octa/octa-dark.png" style="opacity: 1" />
        <h1 class="title">OCTA</h1>
    </a>

    <a class="iconR2">
        <fa-icon [icon]="faBell"></fa-icon>
    </a>

    <a (click)="header_trg('sidebar')" id="trg_nav" class="iconR">
        <fa-icon [icon]="FAIcon"></fa-icon>
    </a>

    <div class="section-divider"></div>
</div>	